import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Feature({ v }) {
  if (!v.showFeature) return null;
  return (
    <>
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeDialog}>
        <div className="gp-venster gp-vast" onClick={v.stopProp} style={{ "width": "min(640px,100%)", "maxHeight": "calc(100vh - 60px)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "flex": "0 0 auto" }}>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Ideeënbus
            </div>
            <button onClick={v.closeDialog} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          {/* flexWrap: op een telefoon passen Open, Gedaan en Afgewezen samen niet op
              één regel. Zonder dit liep het derde tabje het venster uit. */}
          <div style={{ "display": "flex", "gap": "8px", "flexWrap": "wrap", "flex": "0 0 auto" }}>
            {toList(v.featureTabs).map((t, $index) => (
              <React.Fragment key={$index}>
                <button onClick={t?.onClick} className="gp-btn" title={t?.label} style={css(t?.style)}>
                  {t?.heeftIcoon ? (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                      {t?.icoon === 'vink'
                        ? <path d="M20 6 9 17l-5-5" />
                        : <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>}
                    </svg>
                  ) : <Interp v={t?.label} />}
                  <span style={css(t?.countStyle)}>
                    <Interp v={t?.count} />
                  </span>
                </button>
              </React.Fragment>
            ))}
          </div>
          {v.featureEmpty ? (<>
            <div style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--tekst-3)", "lineHeight": "1.4", "border": "3px dashed var(--rand-stippel)", "borderRadius": "12px", "padding": "16px", "textAlign": "center" }}>
              <Interp v={v.featureEmptyLabel} />
            </div>
          </>) : null}
          <div style={{ "display": "flex", "flexDirection": "column", "gap": "8px", "overflowY": "auto", "overscrollBehavior": "contain", "minHeight": "0", "flex": "1 1 auto" }}>
            {toList(v.featureFeed).map((f, $index) => (
              <React.Fragment key={$index}>
                <div style={css(f?.rowStyle)}>
                  {' '}
                  <div style={{ "minWidth": "0", "flex": "1 1 auto", "display": "flex", "flexDirection": "column", "gap": "7px" }}>
                    <div style={{ "display": "flex", "alignItems": "center", "gap": "8px", "minWidth": "0" }}>
                      <img alt="" src={f?.avatarUrl} style={{ "width": "28px", "height": "28px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                      <span style={{ "fontSize": "13px", "fontWeight": "700", "color": "var(--ink)", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={f?.author} />
                      </span>
                      <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-3)", "flex": "1 1 auto", "minWidth": "0", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={f?.meta} />
                      </span>
                      {f?.solved ? (<>
                        <span style={{ "display": "flex", "alignItems": "center", "gap": "4px", "flex": "0 0 auto", "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--groen-ink)", "background": "var(--groen-vlak)", "border": "2px solid var(--groen)", "borderRadius": "999px", "padding": "2px 8px" }}>
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                          {"\n                    gedaan\n                  "}
                        </span>
                      </>) : null}
                      {f?.declined ? (<>
                        <span style={{ "display": "flex", "alignItems": "center", "gap": "4px", "flex": "0 0 auto", "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-2)", "background": "var(--lila-diep)", "border": "2px solid var(--tekst-3)", "borderRadius": "999px", "padding": "2px 8px" }}>
                          <Kruis maat={11} />
                          {"\n                    afgewezen\n                  "}
                        </span>
                      </>) : null}
                    </div>
                    <div style={css(f?.textStyle)}>
                      <Interp v={f?.text} />
                    </div>
                  </div>
                  {' '}
                  <div style={css(f?.actionsStyle)}>
                    {' '}
                    {f?.showVote ? (<>
                      {' '}
                      <button onClick={f?.onVote} title={f?.voteTitle} className="gp-swatch" style={css(f?.voteStyle)}>
                        {' '}
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="m5 14 7-7 7 7" />
                        </svg>
                        {' '}
                        <span style={{ "fontSize": "14px", "fontWeight": "700", "lineHeight": "1" }}>
                          <Interp v={f?.votes} />
                        </span>
                        {' '}
                      </button>
                      {' '}
                    </>) : null}
                    {' '}
                    {v.isMaintainer ? (<>
                      {' '}
                      <div style={{ "display": "flex", "gap": "6px", "flex": "0 0 auto" }}>
                        <button onClick={f?.onToggleSolved} title={f?.solveTitle} className="gp-swatch" style={css(f?.solveStyle)}>
                          {' '}
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                          {' '}
                        </button>
                        <button onClick={f?.onToggleDeclined} title={f?.declineTitle} className="gp-swatch" style={css(f?.declineStyle)}>
                          {' '}
                          <Kruis maat={15} />
                          {' '}
                        </button>
                      </div>
                      {' '}
                    </>) : null}
                    {' '}
                  </div>
                  {' '}
                </div>
              </React.Fragment>
            ))}
          </div>
          {v.hasFeatureError ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600", "flex": "0 0 auto" }}>
              <Interp v={v.featureError} />
            </div>
          </>) : null}
          {v.hasFeatureNote ? (<>
            <div style={{ "fontSize": "12px", "color": "var(--tekst-3)", "fontWeight": "600", "flex": "0 0 auto" }}>
              <Interp v={v.featureNote} />
            </div>
          </>) : null}
          {v.featureSent ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--groen)", "fontWeight": "700", "flex": "0 0 auto" }}>
              Bedankt! Je ideetje staat in de lijst. 🎉
            </div>
          </>) : null}
          <div style={{ "display": "flex", "gap": "8px", "flex": "0 0 auto", "borderTop": "3px solid var(--lila)", "paddingTop": "14px" }}>
            <input type="text" value={v.featureText ?? ''} onInput={v.onFeatureInput} placeholder="Jouw ideetje voor de paal" style={{ "flex": "1 1 auto", "minWidth": "0" }} />
            <button onClick={v.submitFeature} className="gp-btn pink" disabled={v.featureSending} style={{ "flex": "0 0 auto", "justifyContent": "center", "height": "46px", "borderRadius": "16px" }}>
              <Interp v={v.featureBtnLabel} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
